import { render, staticRenderFns } from "./OrdenCompraEjecutivos.vue?vue&type=template&id=aee357c6&"
import script from "./OrdenCompraEjecutivos.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraEjecutivos.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraEjecutivos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports